function isString(value) {
  const type = typeof value;
  return type == "string" || (type == "object" && value instanceof String);
}

function createUnloadHandler(trigger, message) {
  return function leaving(e) {
    e = e || window.event;
    if (trigger()) {
      var confirmationMessage = message;
      e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
      return confirmationMessage; // Gecko, WebKit, Chrome <34
    }
  };
}

function createRouteLeaveHandler(trigger, message) {
  return function beforeRouteLeave(to, from, next) {
    if (!this.$validate) {
      next();
    } else {
      if (!trigger() || (trigger() && confirm(message))) {
        this.$isModified = false;
        next();
      } else {
        next(false);
      }
    }
  };
}

export function createDirective(options, vm) {
  var defaultMessage =
    options.message ||
    "You have unsaved work. Are you sure you want to leave this page?";
  return {
    bind(el, { value, modifiers }, vnode) {
      var vueRouterDisabled = modifiers["vue-router-disable"];
      var beforeunloadDisabled = modifiers["beforeunload-disable"];
      var testerOnlyEnabled = modifiers["tester-only"];

      var message = defaultMessage;
      var tester = () => true; // default tester always return true :-)

      if (isString(value)) {
        message = value;
      } else {
        value = value || {};
        if (value.message) {
          message = value.message;
        }
        if (value.tester) {
          tester = value.tester;
        }
      }

      var trigger = () => vm.isModified || !tester();
      var inputs = [];

      function changeHandle() {
        vm.isModified = true;
      }

      if (!testerOnlyEnabled) {
        el.addEventListener("change", changeHandle);
      }

      // for refresh, location.href
      if (!beforeunloadDisabled) {
        var unloadHandler = createUnloadHandler(trigger, message);
        window.addEventListener("beforeunload", unloadHandler);
      }

      // for vue router
      if (!vueRouterDisabled) {
        var routeLeaveHandler = createRouteLeaveHandler(trigger, message);

        if (!vnode.context.$options["beforeRouteLeave"]) {
          // ref. https://github.com/vuejs/vue/blob/dev/src/core/instance/init.js
          // vnode.context.$options.__proto__ == vnode.context.constructor.options
          vnode.context.constructor.options["beforeRouteLeave"] = [];
        }
        vnode.context.$options["beforeRouteLeave"].push(routeLeaveHandler);
      }

      // unbind method
      el._vuePreventBackUnbind = function() {
        if (!testerOnlyEnabled) {
          el.removeEventListener("change", changeHandle);
        }

        // for refresh, location.href
        if (!beforeunloadDisabled) {
          window.removeEventListener("beforeunload", unloadHandler);
        }

        // for vue router
        if (!vueRouterDisabled) {
          vnode.context.$options["beforeRouteLeave"].splice(
            vnode.context.$options["beforeRouteLeave"].indexOf(
              routeLeaveHandler
            ),
            1
          );
          if (vnode.context.$options["beforeRouteLeave"].length === 0) {
            delete vnode.context.$options["beforeRouteLeave"];
          }
        }
      };
    },
    unbind(el, binding, vnode) {
      el._vuePreventBackUnbind();
      delete el._vuePreventBackUnbind;
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/directive/directive.js
// module id = null
// module chunks = 